/* eslint-disable import/prefer-default-export */

import axios from './axios';

export const getClientRiskLevels = ({ params } = {}) => axios.get(`client_risk_levels`, { params });